import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, toRefs, ref, watch, computed } from "vue";
import { useRoute } from "vue-router/composables";
import AssetComponent from "@/components/AssetComponent.vue";
import SmartAssetName from "@/components/SmartAssetName.vue";
import AssetAlertList from "@/components/AssetAlertList.vue";
import { DecoratedAsset } from "@/types";
import { getProperty } from "@/config/asset";
import { isBlank } from "@/utils/string";

export interface Props {
  asset: DecoratedAsset | null;
  childAssets?: DecoratedAsset[];
  showDetails?: boolean;
  showModel?: boolean;
  isChild?: boolean;
  onDashboard?: boolean;
  loading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetControlPanel',
  props: {
    asset: null,
    childAssets: { default: () => [] },
    showDetails: { type: Boolean, default: false },
    showModel: { type: Boolean, default: false },
    isChild: { type: Boolean, default: false },
    onDashboard: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { asset: DecoratedAsset | null, childAssets: DecoratedAsset[], showDetails: boolean, showModel: boolean, isChild: boolean, onDashboard: boolean, loading: boolean }



const { asset, showDetails, showModel } = toRefs(props);
const route = useRoute();
const componentKey = ref(0);

watch(route, () => {
  componentKey.value++;
});

const manufacturer = computed(() => {
  if (!showDetails.value) return null;
  return asset.value?.manufacturer?.name ?? null;
});

const model = computed(() => {
  if (!(showDetails.value || showModel.value)) return null;
  return asset.value?.assetModel?.name ?? null;
});

const firmware = computed(() => {
  if (!asset.value) return null;
  const property = getProperty(asset.value, "firmware_version").value;
  return isBlank(property) ? null : property;
});

const assetRoute = computed(() => {
  if (!asset.value || isCurrentAsset.value) return null;
  return { name: "asset", params: { assetUuid: asset.value.assetUuid } };
});

const isCurrentAsset = computed(() => {
  return asset.value?.assetUuid === route.params.assetUuid;
});

return { __sfc: true,props, asset, showDetails, showModel, route, componentKey, manufacturer, model, firmware, assetRoute, isCurrentAsset, AssetComponent, SmartAssetName, AssetAlertList }
}

})